module.exports = vue_platform_v1;